var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6801 21.2543C43.1439 21.6824 43.1728 22.4054 42.7447 22.8692L24.459 42.6787C24.0309 43.1425 23.3078 43.1714 22.844 42.7433C22.3802 42.3152 22.3513 41.5922 22.7794 41.1284L41.0651 21.3189C41.4933 20.8551 42.2163 20.8261 42.6801 21.2543ZM25.9049 23.6178C27.1673 23.6178 28.1906 24.6412 28.1906 25.9036C28.1906 27.1659 27.1673 28.1893 25.9049 28.1893C24.6426 28.1893 23.6192 27.1659 23.6192 25.9036C23.6192 24.6412 24.6426 23.6178 25.9049 23.6178ZM25.9049 21.3321C28.4297 21.3321 30.4764 23.3788 30.4764 25.9036C30.4764 28.4283 28.4297 30.475 25.9049 30.475C23.3802 30.475 21.3335 28.4283 21.3335 25.9036C21.3335 23.3788 23.3802 21.3321 25.9049 21.3321ZM41.9049 38.094C41.9049 36.8317 40.8816 35.8083 39.6192 35.8083C38.3568 35.8083 37.3335 36.8317 37.3335 38.094C37.3335 39.3564 38.3568 40.3797 39.6192 40.3797C40.8816 40.3797 41.9049 39.3564 41.9049 38.094ZM44.1906 38.094C44.1906 35.5693 42.1439 33.5226 39.6192 33.5226C37.0945 33.5226 35.0478 35.5693 35.0478 38.094C35.0478 40.6188 37.0945 42.6655 39.6192 42.6655C42.1439 42.6655 44.1906 40.6188 44.1906 38.094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentRoundedBlue);
export default __webpack_public_path__ + "static/media/percent-rounded-blue.46b9c5f2792af5d53e6af54883a0b608.svg";
export { ForwardRef as ReactComponent };